/**
 * @flow
 * @relayHash b0f81e1e85622416db3d12b9dffce3ed
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type duplicateHyreferralCampaignInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type duplicateCampaignMutationVariables = {|
  input: duplicateHyreferralCampaignInput
|};
export type duplicateCampaignMutationResponse = {|
  +duplicateHyreferralCampaign: ?{|
    +clientMutationId: ?string,
    +hyreferralCampaign: ?{|
      +createdAt: any,
      +id: string,
      +propertyId: string,
      +propertyName: ?string,
      +title: string,
      +reward: ?number,
      +active: boolean,
      +friendsCount: ?string,
      +residentsCount: ?string,
    |},
  |}
|};
export type duplicateCampaignMutation = {|
  variables: duplicateCampaignMutationVariables,
  response: duplicateCampaignMutationResponse,
|};
*/


/*
mutation duplicateCampaignMutation(
  $input: duplicateHyreferralCampaignInput!
) {
  duplicateHyreferralCampaign(input: $input) {
    clientMutationId
    hyreferralCampaign {
      createdAt
      id
      propertyId
      propertyName
      title
      reward
      active
      friendsCount
      residentsCount
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "duplicateHyreferralCampaignInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "duplicateHyreferralCampaign",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "duplicateHyreferralCampaignPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyreferralCampaign",
        "storageKey": null,
        "args": null,
        "concreteType": "HyreferralCampaign",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "propertyId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "propertyName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "reward",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "active",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "friendsCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "residentsCount",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "duplicateCampaignMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "duplicateCampaignMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "duplicateCampaignMutation",
    "id": null,
    "text": "mutation duplicateCampaignMutation(\n  $input: duplicateHyreferralCampaignInput!\n) {\n  duplicateHyreferralCampaign(input: $input) {\n    clientMutationId\n    hyreferralCampaign {\n      createdAt\n      id\n      propertyId\n      propertyName\n      title\n      reward\n      active\n      friendsCount\n      residentsCount\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '60d54a4c70af08e8147599ac04b6d397';
module.exports = node;
